import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=91474ece&scoped=true"
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"
import style0 from "./Point.vue?vue&type=style&index=0&id=91474ece&prod&lang=less&scoped=true"
import style1 from "./Point.vue?vue&type=style&index=1&id=91474ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91474ece",
  null
  
)

export default component.exports